import { UAlogo } from "../assests";
import { paymentlogo } from "../assests";
import { ImGithub } from "react-icons/im";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram, FaPerson, FaPersonFallingBurst } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { FaHome } from "react-icons/fa";
import { FaMap } from "react-icons/fa6";
import { CgProfile } from "react-icons/cg";
import { FaPaypal } from "react-icons/fa";
import { RiCustomerService2Fill } from "react-icons/ri";

const Footer=()=>{
    return(<div className="bg-black text-[#949494] py-20 font-titleFont w-[100%]">
      <div>
       <div className="max-w-screen-xl mx-auto grid grid-cols-4">
        {/* col1 ICons */}

       <div className="flex flex-col gap-7 items-start">
  <img src={UAlogo} 
  className="bg-white w-20 rounded-lg" alt="" />
       <span>@umarAhmadofficial</span>
       <img  className="w-[70%]"src={paymentlogo} alt="" />
       <div className="flex gap-3">
        <ImGithub     className="hover:text-white duration-300 text-xl"></ImGithub>
        <FaFacebookF  className="hover:text-white duration-300 text-xl"></FaFacebookF>
        <FaTwitter    className="hover:text-white duration-300 text-xl"></FaTwitter>
        <FaInstagram  className="hover:text-white duration-300 text-xl"></FaInstagram>   
        <FaYoutube    className="hover:text-white duration-300 text-xl"></FaYoutube>
        <FaHome       className="hover:text-white duration-300 text-xl"></FaHome>   
       </div>
       
       </div>

       {/* col2 */}
       <div className="flex flex-col items-start justify-between">
       <div className="flex gap-5 justify-center items-center mb-4 text-xl text-white"><FaMap></FaMap> <span>Locate Us</span></div>
       <div>
        <p>Nit Kurukshtera</p>
        <p>132000</p>
        <p>Haryana</p>
        <p>India</p>
        <p>Phone: 9476216642</p>
        <p>e-mail: uacart@gmail.com</p>
        </div>
       </div>
  

       <div className="flex flex-col items-start gap-5">
       <div className="flex gap-5 justify-center items-center mb-4 text-xl text-white"><span>Profile</span></div>
       <div>
        <p className="flex gap-3 mb-2 justify-start items-center hover:text-white duration-300"><CgProfile /> <span>My account</span></p>
        <p className="flex gap-3 mb-2 justify-start items-center hover:text-white duration-300"><FaPaypal></FaPaypal><span>Check out</span></p>
        <p className="flex gap-3 mb-2 justify-start items-center hover:text-white duration-300"><FaHome></FaHome><span>Order Tracking</span></p>
        <p className="flex gap-3 mb-2 justify-start items-center hover:text-white duration-300"><RiCustomerService2Fill /><span>Help & Support</span></p>
    
        </div>
       </div>

       {/* col4 */}

       <div className="flex flex-col gap-5  items-center mt-2">
        <input className="bg-transparent border px-4 py-2 text-sm w-full" placeholder="email" type="text" />
        <button className="border border-white w-40  rounded-lg hover:bg-slate-400 hover:text-white duration-300">Subscribe</button>
       </div>



       </div>
      </div> 
    </div>)
}
export default Footer;